import styled from 'styled-components';
import WithDirection from '../../../config/withDirection';

export default WithDirection(styled.div`
    min-width: 800px;

    > * { padding: 0 64px; }
    h2 {
        display: flex;
        align-items: center;
        margin: 0;
        min-height: 60px;
        background-color: rgba(252, 252, 252, 1);
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);
    }

    /*
    please user classname instead to improve readability
    */
    h2 + * {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 60px;
        background-color: rgba(219, 219, 219, 0.35);
    }

    /*
    please user classname instead to improve readability
    */
    h2 + * * {
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 300;
        color: rgba(35, 31, 32, 1);
        letter-spacing: 0.01em;
    }

    /*
    please user classname instead to improve readability
    */
    h2 ~ :last-child {
        padding-top: 14px;
        padding-bottom: 42px;
    }

    /*
    please user classname instead to improve readability
    */
    h2 ~ :last-child > :first-child {
        margin-bottom: 17px;
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.04em;
    }

    .border-wrapper { display: inline-flex; margin-bottom: 30px; border-radius: 19px; height: 38px; }

    // -- Budget Selector
    .budget-selector {
        justify-content: flex-start;
        align-items: center;
        border: 1px solid rgba(151, 151, 151, 1);
    }
    .budget-selector input:only-child {
        flex-grow: 1;
        border-width: 0;
        height: 38px;
        background-color: transparent;
        padding-right: 13px;
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(64, 55, 57, 1);
        text-align: right;
        letter-spacing: 0.04em;
        box-shadow: none;
    }
    .budget-selector input:only-child:focus { outline-width: 0; }

    .symbol-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 41px;
        height: 38px;
        padding-left: 5px;
        min-width: 41px;
        border-right: 1px solid rgba(151, 151, 151, 1);
    }
    .symbol-wrapper div {
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 300;
        color: rgba(147, 147, 147, 1);
        letter-spacing: 0.07em;
    }

    // -- Add Budget Button
    button.border-wrapper {
        justify-content: center;
        padding: 0 21px;
        background-color: rgba(60, 211, 207, 1);
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 0.01em;
    }

    @media screen and (max-width: 767px) {
        min-width: unset;
        width: calc(100vw - 32px);

        > * { padding: 0 25px; }
    }
`);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/AddBudgetModal/Wrapper.js